export const actionType = {
    ADDTRIP_REQUEST: 'ADDTRIP_REQUEST',
    ADDTRIP_SUCCESS: 'ADDTRIP_SUCCESS',
    ADDTRIP_FAILURE: 'ADDTRIP_FAILURE', 
};